import React from 'react';
import { motion } from 'framer-motion';
import { FiTarget, FiZap, FiBarChart2, FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const VideoAdvertSection = () => {
  return (
    <section id="advert-video" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-emerald-600 font-black text-sm uppercase tracking-[0.2em] mb-4 block">Advert Video Maker</span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-8 leading-tight">
              High-Converting <span className="text-emerald-600">Video Ads</span> Created in Hours
            </h2>
            <p className="text-xl text-slate-600 mb-10 leading-relaxed font-medium">
              Stop losing money on static ads that people scroll past. Our AI-powered advert video maker builds psychological triggers and high-impact visuals that force engagement and drive sales.
            </p>
            
            <div className="space-y-6 mb-10">
              {[
                { icon: FiTarget, title: 'Algorithm Optimized', desc: 'Designed specifically for Meta, TikTok, and YouTube algorithms.' },
                { icon: FiZap, title: 'Rapid Variations', desc: 'Create 10+ variations for A/B testing in the time it takes to make one.' },
                { icon: FiBarChart2, title: 'Data-Driven Hooks', desc: 'We use proven high-retention hooks to keep viewers watching.' }
              ].map((item, i) => (
                <div key={i} className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-emerald-50 rounded-xl flex items-center justify-center text-emerald-600">
                    <SafeIcon icon={item.icon} />
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900">{item.title}</h4>
                    <p className="text-slate-500 text-sm">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <a 
              href="https://go.digitalgigs.eu/chat" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="inline-flex items-center text-emerald-600 font-black text-lg hover:text-emerald-700 group"
            >
              Start Creating Adverts <SafeIcon icon={FiArrowRight} className="ml-2 group-hover:translate-x-2 transition-transform" />
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="mt-12 lg:mt-0 relative"
          >
            <div className="aspect-[4/5] bg-slate-100 rounded-[3rem] overflow-hidden border border-slate-200 shadow-2xl">
              <video 
                src="https://media-manager-c.questera.ai/greta-media/fafed1dc96bdeaff472e762fc9535f37237b73cd078ba929908d8fc9f91ee4faeb3717965c5074a04f18e80ee0d17e20/videos/dmlkZW8vbXA0/3113eb0665ee2139533009a1a6f32fcb.mp4" 
                autoPlay loop muted playsInline 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent" />
              <div className="absolute bottom-8 left-8 right-8">
                <div className="bg-white/10 backdrop-blur-md border border-white/20 p-4 rounded-2xl">
                  <p className="text-white font-bold text-sm">Campaign: Summer Sale 2024</p>
                  <div className="flex items-center gap-2 mt-2">
                    <div className="h-1.5 flex-grow bg-white/20 rounded-full overflow-hidden">
                      <div className="h-full bg-emerald-400 w-3/4" />
                    </div>
                    <span className="text-white text-[10px] font-black uppercase">High ROI</span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default VideoAdvertSection;
